export interface IPaginatedSearchOptions {
  viewMode: string;
  currentPage: number;
  pageSize: number;
}

export class PaginatedSearchOptions implements IPaginatedSearchOptions {
  viewMode: string;
  currentPage: number;
  pageSize: number;

  constructor();
  constructor(obj: IPaginatedSearchOptions);
  constructor(obj?: IPaginatedSearchOptions) {
    this.viewMode = obj?.viewMode ?? 'TABLE';
    this.currentPage = obj?.currentPage ?? 1;
    this.pageSize = obj?.pageSize ?? 10;
  }
}
